import { packages } from '@shared/api/services'
import { queryClient } from '@shared/api/query-client'
import { useMutation } from '@tanstack/react-query'

const removePackageFromCache = (id) => {
	queryClient.setQueryData(['profile-packages'], (cached) => {
		if (!cached) return cached
		const payload = cached.data
		const without = (list) => list.filter((pack) => pack?.id !== id)
		if (Array.isArray(payload)) return { ...cached, data: without(payload) }
		if (Array.isArray(payload?.data)) return { ...cached, data: { ...payload, data: without(payload.data) } }
		return cached
	})
}

export const useDeleteProfilePackage = (onSuccess = () => {}) => {
	return useMutation({
		mutationFn: packages.deleteProfilePackage,
		onSuccess: (_data, id) => {
			removePackageFromCache(id)
			queryClient.invalidateQueries(['profile-packages'])
			onSuccess()
		},
	})
}
